/** @jsx jsx */
import { jsx } from "theme-ui"
import Highlights from "../highlights"

const HighlightsPattern = ({ blade }) => {
  return <Highlights title={blade.title} />
}

export default HighlightsPattern
